export default "__VITE_ASSET__M0N8fVoh__"